import { render } from "./BasicModal.vue?vue&type=template&id=c3b6a968&scoped=true&ts=true"
import script from "./BasicModal.vue?vue&type=script&lang=ts"
export * from "./BasicModal.vue?vue&type=script&lang=ts"

import "./BasicModal.vue?vue&type=style&index=0&id=c3b6a968&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/hems-frontend-vue_au_v1.33.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3b6a968"]])

export default __exports__